import type { EdutainmentApplication } from '../../types';

export const RELEASED_APPLICATIONS: EdutainmentApplication[] = [
  {
    _id: '007',
    name: '瑜珈初階班',
    plans: ['銀卡會員', '金卡會員', '白金卡會員'],
    category: '運動',
    reviewDeadline: 1752249600001,
    autoReleaseDate: 1752336000001,
    status: '報名中',
    currentEnrollment: 8,
    minimumEnrollment: 10,
    startDate: 1760198400001,
    endDate: 1775923200001,
    times: ['星期一10:00~11:30', '星期三10:00~11:30'],
    teacher: '吳瑜珈',
    administrator: '周主任',
  },
  {
    _id: '008',
    name: '水彩繪畫班',
    plans: ['金卡會員', '鑽卡會員'],
    category: '藝術',
    reviewDeadline: 1753459200001,
    autoReleaseDate: 1753545600001,
    status: '已上架',
    currentEnrollment: 0,
    minimumEnrollment: 8,
    startDate: 1761408000001,
    endDate: 1777132800001,
    times: ['星期二13:00~15:00', '星期五13:00~15:00'],
    teacher: '李水彩',
    administrator: '劉主任',
  },
  {
    _id: '009',
    name: '民謠吉他班',
    plans: ['銀卡會員', '金卡會員', '鑽卡會員', '白金卡會員'],
    category: '音樂',
    reviewDeadline: 1754668800001,
    autoReleaseDate: 1754755200001,
    status: '已開成',
    currentEnrollment: 6,
    minimumEnrollment: 5,
    startDate: 1762617600001,
    endDate: 1778342400001,
    times: ['星期二19:00~20:30', '星期四19:00~20:30'],
    teacher: '張吉他',
    administrator: '黃主任',
  },
  {
    _id: '010',
    name: '韓式料理班',
    plans: ['金卡會員', '白金卡會員'],
    category: '烹飪',
    reviewDeadline: 1755878400001,
    autoReleaseDate: 1755964800001,
    status: '已開成',
    currentEnrollment: 15,
    minimumEnrollment: 12,
    startDate: 1763827200001,
    endDate: 1779552000001,
    times: ['星期一15:00~17:00', '星期四15:00~17:00'],
    teacher: '金廚師',
    administrator: '許主任',
  },
  {
    _id: '011',
    name: '英語會話班',
    plans: ['銀卡會員', '金卡會員', '鑽卡會員'],
    category: '語言',
    reviewDeadline: 1757088000001,
    autoReleaseDate: 1757174400001,
    status: '已上架',
    currentEnrollment: 0,
    minimumEnrollment: 8,
    startDate: 1765036800001,
    endDate: 1780761600001,
    times: ['星期一19:00~20:30', '星期三19:00~20:30'],
    teacher: 'John Smith',
    administrator: '謝主任',
  },
  {
    _id: '012',
    name: '插花藝術班',
    plans: ['金卡會員', '鑽卡會員', '白金卡會員'],
    category: '技藝',
    reviewDeadline: 1758297600001,
    autoReleaseDate: 1758384000001,
    status: '報名中',
    currentEnrollment: 4,
    minimumEnrollment: 6,
    startDate: 1766246400001,
    endDate: 1781971200001,
    times: ['星期三14:00~16:00', '星期六14:00~16:00'],
    teacher: '陳花藝',
    administrator: '楊主任',
  },
];
